import {
  inputBaseClasses,
  listItemIconClasses,
  ThemeOptions,
  typographyClasses,
} from '@mui/material';
import { Z_INDEXES } from 'src/constants/z-indexes';

type ZIndexes = typeof Z_INDEXES;

declare module '@mui/material/styles' {
  interface ZIndex {
    app: {
      [key in keyof ZIndexes]: number;
    };
  }

  interface Theme {
    zIndex: ZIndex;
  }

  interface ThemeOptions {
    zIndex?: Partial<ZIndex>;
  }
}

export const theme: ThemeOptions = {
  zIndex: {
    app: {
      ...Z_INDEXES,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: () => ({
          [`&:has(.${inputBaseClasses.root}.${inputBaseClasses.disabled})`]: {
            pointerEvents: 'none',
          },
        }),
        option: () => ({
          [`&, & .${typographyClasses.root}`]: {
            fontSize: '0.85rem',
          },
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          [`&.${inputBaseClasses.disabled}`]: {
            color: theme.palette.custom.OV.sys.onSurfaceVariant,
            pointerEvents: 'none',

            [`.${inputBaseClasses.input}.${inputBaseClasses.disabled}`]: {
              color: theme.palette.custom.OV.sys.onSurfaceVariant,
              textFillColor: theme.palette.custom.OV.sys.onSurfaceVariant,
            },
          },
        }),
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: () => ({
          [`&, & .${typographyClasses.root}`]: {
            fontSize: '0.85rem',
            gap: '0.8rem',
          },
          [`& .${listItemIconClasses.root}`]: {
            minWidth: 'auto',
          },
          '& .material-symbols-outlined': {
            fontSize: '1.4rem',
            width: '1.4rem',
            height: '1.4rem',
          },
        }),
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: () => ({
          [`&, & .${typographyClasses.root}`]: {
            fontSize: '0.85rem',
          },
        }),
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: () => ({
          '&': {
            fontSize: '0.85rem',
          },
          '& .material-symbols-outlined': {
            fontSize: '1.4rem',
            width: '1.4rem',
            height: '1.4rem',
          },
        }),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: ({ theme }) => ({
          '.MuiButtonBase-root:hover': {
            backgroundColor: theme.palette.custom.secondary.secondary60,
          },
          '.MuiButtonBase-root.Mui-selected': {
            backgroundColor: theme.palette.custom.secondary.secondary50,
            '&:hover': {
              backgroundColor: theme.palette.custom.secondary.secondary40,
            },
          },
        }),
      },
    },
  },
};

